module.exports = __webpack_public_path__ + "img/checkedAdsorb.7db80520.png";